import { render, staticRenderFns } from "./ClientRow.vue?vue&type=template&id=0515c398&scoped=true"
import script from "./ClientRow.vue?vue&type=script&lang=js"
export * from "./ClientRow.vue?vue&type=script&lang=js"
import style0 from "./ClientRow.vue?vue&type=style&index=0&id=0515c398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0515c398",
  null
  
)

export default component.exports